import React, { useState, useEffect } from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import styled from '@mui/system/styled';

import { Auth } from 'aws-amplify';
import { useDispatch, useSelector } from 'react-redux';
import { getInvoiceData } from './PrintInvoicesApi';
import { PROVIDER_INVOICE_URL} from '../../../../constants';
import '../../../../App.css';

import InvoiceCover from './InvoiceCover';
import ProviderInvoice from './ProviderInvoice';

export const Invoices = React.forwardRef((props, ref) => {
  const [user, setUser] = useState(null);
  const [printInvoiceData, setPrintInvoiceData] = useState([]);
  const [ date, setDate] = useState();
  const [ time, setTime] = useState();
  const invoiceCbpIds = useSelector((state) => state.invoiceCbpIds);
  const invoiceReferenceData = useSelector((state) => state.invoiceReferenceData?.data);
  const { selectedMonth, months } = invoiceReferenceData;
  const {iUnits, setIUnits} = useState(0);
  const {iUnitsAuth, setIUnitsAuth} = useState(0);
  const {iUnitsTot, setIUnitsTot} = useState(0);

  const STOP_REGION = process.env.REACT_APP_STOP_REGION
  const STOP_REGION_FAX = process.env.REACT_APP_STOP_REGION_FAX

  // const TableItem = styled('div')(({ theme }) => ({
  //   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  //   border: '1px solid',
  //   borderColor: theme.palette.mode === 'dark' ? '#444d58' : '#ced7e0',
  //   padding: theme.spacing(.5),
  //   borderRadius: '4px',
  //   textAlign: 'center',
  // }));

  const days = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
      const now = new Date()
      const date = (now.getMonth() + 1) + '/' +  now.getDate() + '/' + now.getFullYear()
      setDate(date);

      let hours = now.getHours()
      hours = hours % 12
      hours = hours ? hours : 12
      let minutes = now.getMinutes();
      minutes = minutes < 10 ? '0'+minutes : minutes
      const time = hours + ':' + minutes + ' ' + ((now.getHours() >= 12) ? 'PM' : 'AM')
      setTime(time)      
    }
    getUser().then((userData) => setUser(userData));
  }, [user?.signInUserSession.accessToken.jwtToken]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
    .then((userData) => userData)
    .catch(() => console.log('Not signed in'));
  };

  const fetchData = async () => {
    var commonParams = `${PROVIDER_INVOICE_URL}${selectedMonth}`;
    if (invoiceCbpIds.length > 0)
      commonParams += `&CBPIds=${invoiceCbpIds}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const invoiceData = await getInvoiceData({
      commonParams,
      authorization,
    });
    const invoices = transform(invoiceData)
    invoices.sort((a, b) => a.cboName.localeCompare(b.cboName));    
    console.log('### invoices');
    console.log(invoices);
    setPrintInvoiceData(invoices);
  };

  const transform = (raw) => {
  //console.log(raw);

    var invoices = []
    for (let i = 0; i < raw.length; i++) {
      var cboID = raw[i]['cboID']
      if (!invoices.some(inv => inv.cboID === cboID)) {
        //add a new top level cbo invoice
        invoices.push({
          "cboID": cboID,
          "dayCount": raw[i]['dayCount'], 
          "mthID": raw[i]['mthID'], 
          "cboName": raw[i]['cboName'],
          "modResYN": raw[i]['modResYN'], 
          "cboCde": raw[i]['cboCde'], 
          "orgKey": raw[i]['orgKey'], 
          "cntKey": raw[i]['cntKey'], 
          "orgVer_CntID": raw[i]['orgVer_CntID'],
          "cntKey": raw[i]['cntKey'], 
          "orgAdr": raw[i]['orgAdr'], 
          "orgCity": raw[i]['orgCity'], 
          "orgState": raw[i]['orgState'], 
          "orgZip": raw[i]['orgZip'], 
          "orgPhone": raw[i]['orgPhone'], 
          "orgFax": raw[i]['orgFax'], 
          "cboInvID": raw[i]['cboInvID'], 
          "cboInvAmt": raw[i]['cboInvAmt'], 
          "cboInvTmtAmt": raw[i]['cboInvTmtAmt'], 
          "cboInvDcpAdjAmt": raw[i]['cboInvDcpAdjAmt'], 
          "cboInvDcpInMthTtlActlAmt": raw[i]['cboInvDcpInMthTtlActlAmt'], 
          "cbo_ModID": raw[i]['cbo_ModID'], 
          "auths": []
        })
      }
      //console.log(invoices);

      //retrieve the top level invoice
      var invoice = invoices.find(cbo => cbo.cboID === cboID);

      var authType = raw[i]['sapAth_AthTypID']
      if (!invoice.auths.some(auth => auth.type === authType)) {
        invoice.auths.push({"type": authType, "participants": []})
      }

      //retrieve auth type from invoice and add participant
      var sapAuthType = invoice.auths.find(type => type.type === authType)
      sapAuthType.participants.push(raw[i])

    }
    //console.log(invoices)
    for (let iInvoice = 0; iInvoice < invoices.length; iInvoice++) {
      let invoice = invoices[iInvoice];
      let invoiceIServices = 0
      let invoiceIRate = 0;
      let invoiceGServices = 0
      let invoiceGRate = 0;
      
      for (let iAuth = 0; iAuth < invoice.auths.length; iAuth++) {
        let auth = invoice.auths[iAuth];
        let authIServices = 0;
        let authIRate = 0;
        let authGServices = 0;
        let authGRate = 0;

        for (let iParticipant = 0; iParticipant < auth.participants.length; iParticipant++) {
          let participant = auth.participants[iParticipant];
          let participantIServices = 0;
          let participantIRate = 0;
          let participantGServices = 0;
          let participantGRate = 0;
          for (let day = 1; day<=days.length; day++) {
            if (participant['i'+day.toString()] != null) {
              participantIServices++;
              authIServices++;
              invoiceIServices++;
              if (!auth[day.toString()])
                auth[day.toString()] = 0;
              auth[day.toString()]++;
              if (!invoice[day.toString()])
                invoice[day.toString()] = 0;
              invoice[day.toString()]++;
            }

            if (participant['iAmt'+day.toString()] != 0) {
              participantIRate = participant['iAmt'+day.toString()];
              authIRate = participant['iAmt'+day.toString()];
              invoiceIRate = participant['iAmt'+day.toString()];
            }
            if (participant['g'+day.toString()] != null) {
              participantGServices++;
              authGServices++;
              invoiceGServices++;
              if (!auth[day.toString()])
                auth[day.toString()] = 0;
              auth[day.toString()]++;
              if (!invoice[day.toString()])
                invoice[day.toString()] = 0;
              invoice[day.toString()]++;
            }

            if (participant['gAmt'+day.toString()] != 0) {
              participantGRate = participant['gAmt'+day.toString()];
              authGRate = participant['gAmt'+day.toString()];
              invoiceGRate = participant['gAmt'+day.toString()];
            }
          }
          participant.authIServices = participantIServices;
          participant.authIRate = participantIRate;          
          participant.authGServices = participantGServices;
          participant.authGRate = participantGRate;          
        }
        auth.authIServices = authIServices;
        auth.authIRate = authIRate;              
        auth.authGServices = authGServices;
        auth.authGRate = authGRate;              
      }      
      invoice.invoiceIServices = invoiceIServices;
      invoice.invoiceIRate = invoiceIRate;              
      invoice.invoiceGServices = invoiceGServices;
      invoice.invoiceGRate = invoiceGRate;              
    }
    //console.log(invoices);
    return invoices;
  }

  return (
    <div className="print-container" ref={ref}>
      {printInvoiceData.map((invoice, index) => (          
        <div key={index}>
          {/*{
            (index+1) % 2 == 0 &&
            <>
            <div className="page-break-after" />
            </>                      
          }*/}
          {/*<InvoiceCover invoice={invoice} date={date} time={time} />   
          <div className="page-break-after" />*/}
            
          <ProviderInvoice invoice={invoice} />
          <div className="page-break-after" />
            
          
      </div>
      ))}
    </div>
  );
});
